import { queryOptions, useQuery } from '@tanstack/react-query';

import { analyticsApi } from '../api/analytics-api';

import { analyticsKeys } from './analytics-keys';

/** At most one destination per provider, so the list is never paginated. */
export function analyticsDestinationsQueryOptions(storeId: string) {
  return queryOptions({
    queryKey: analyticsKeys.destinations(storeId),
    queryFn: () => analyticsApi.destinations(storeId),
  });
}

export function useAnalyticsDestinations(storeId: string) {
  return useQuery(analyticsDestinationsQueryOptions(storeId));
}
